import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==================== PUBLIC API ====================

// Work Items
export const getWorkItems = async () => {
  const response = await api.get('/work');
  return response.data;
};

export const getWorkItem = async (id) => {
  const response = await api.get(`/work/${id}`);
  return response.data;
};

// About
export const getAbout = async () => {
  const response = await api.get('/about');
  return response.data;
};

// Contact
export const getContactInfo = async () => {
  const response = await api.get('/contact');
  return response.data;
};

export const submitContactMessage = async (message) => {
  const response = await api.post('/contact/message', message);
  return response.data;
};

// ==================== AUTH API ====================

export const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  return response.data;
};

export const register = async (credentials) => {
  const response = await api.post('/auth/register', credentials);
  return response.data;
};

// ==================== ADMIN API ====================

// Work Items Admin
export const createWorkItem = async (item) => {
  const response = await api.post('/admin/work', item);
  return response.data;
};

export const getAllWorkItems = async () => {
  const response = await api.get('/admin/work');
  return response.data;
};

export const updateWorkItem = async (id, item) => {
  const response = await api.patch(`/admin/work/${id}`, item);
  return response.data;
};

export const deleteWorkItem = async (id) => {
  const response = await api.delete(`/admin/work/${id}`);
  return response.data;
};

export const archiveWorkItem = async (id) => {
  const response = await api.patch(`/admin/work/${id}/archive`);
  return response.data;
};

// About Admin
export const updateAbout = async (content) => {
  const response = await api.patch('/admin/about', content);
  return response.data;
};

// Contact Admin
export const updateContactInfo = async (info) => {
  const response = await api.patch('/admin/contact', info);
  return response.data;
};

export const getContactMessages = async () => {
  const response = await api.get('/admin/contact/messages');
  return response.data;
};

export const markMessageRead = async (id) => {
  const response = await api.patch(`/admin/contact/messages/${id}/read`);
  return response.data;
};

export const deleteContactMessage = async (id) => {
  const response = await api.delete(`/admin/contact/messages/${id}`);
  return response.data;
};

// File Upload
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/admin/upload/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const uploadVideo = async (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/admin/upload/video', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percentCompleted);
      }
    }
  });
  return response.data;
};

export const deleteUpload = async (fileId) => {
  const response = await api.delete(`/admin/upload/${fileId}`);
  return response.data;
};

export default api;